import { getIcon } from "mt-components/icons";
import { ProductInclusion } from "../../../../../../graphql/operations";
import { Text } from "../../../../../Atoms/Typography";
import s from "./inclusionsModal.module.scss";

type InclusionRowProps = {
  inclusion: ProductInclusion;
};

export default function InclusionRow({ inclusion }: InclusionRowProps) {
  return (
    <div className={s.Inclusion}>
      <div className={s.InclusionContent}>
        {getIcon(inclusion.icon!, { style: { color: "#d81b60" } })}
        <Text size="normal" bold>
          {inclusion.translation.title}
        </Text>
      </div>
      <Text pre>{inclusion.translation.description}</Text>
    </div>
  );
}
